import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutChangeStopRefnoNoChangeCompareItems extends Layout {
    sourceStopRefnoChangeCompareItem: DataSource;
    tableRefnoChanges: Table;
}
